/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditCheckboxDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `
            <md-input-container class='m--0'>
                <md-checkbox ng-model="value", ng-click="edit()", ng-change="doneEdit()", ng-disabled="canEdit == false">{{label}}</md-checkbox>
            </md-input-container>
 
        `;
        // <input type="checkbox", ng-checked="value">
    }


    public link($scope: any, $element: any, attrs: any): any {
        this.currentValue = $scope.value;
        // $element.addClass('inline-edit-checkbox');
        // $scope.editing = false;

        $element.on('change', function (): any {
            $scope.value = !$scope.value;
            // $scope.editing = false;
            // $element.removeClass('active');
        });

        $scope.edit = function (): any {
            // $scope.editing = true;
            this.currentValue = $scope.value;
            // $element.addClass('active');
            // $element.addClass('');
        };

        $scope.doneEdit = function (): any {
            // $scope.editing = false;
            var newValue: any = $scope.value;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if($scope.saveFunc !== undefined){
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.undo = function (): any {
            // $element.removeClass('active');
            $scope.value = this.currentValue;
        };
    }

    public static DirectiveFn($timeout: any): InlineEditCheckboxDirective {
        return new InlineEditCheckboxDirective($timeout);
    }
}

InlineEditCheckboxDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditCheckbox', InlineEditCheckboxDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_checkbox.directive.ts